import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const mortgageInterestRateAmount = (state, props) => (
  whatIfInnerSelector(state, props).MortgageInterestRate
);

export default mortgageInterestRateAmount;
